// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wz-landing-v2 {
  --ink: #18211b;
  --muted: #5f6c63;
  --soft: #f7fff1;
  --lime: #9bec68;
  --lime-2: #baf58a;
  --line: #dfe8da;
  --dark: #151b18;
  --dark-2: #263327;
  background: #fff;
  color: var(--ink);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  overflow-x: hidden;
}

.wz-landing-v2 * {
  box-sizing: border-box;
  letter-spacing: 0;
}

.wz-landing-v2 button,
.wz-landing-v2 input {
  font: inherit;
}

.wz-hero-v2 {
  min-height: 775px;
  padding: 24px max(16px, calc((100vw - 1150px) / 2)) 120px;
  color: #fff;
  background:
    radial-gradient(circle at 30% 10%, rgba(155, 236, 104, 0.22), transparent 28%),
    linear-gradient(134deg, #172216 0%, #233226 48%, #2e3b48 100%);
}

.wz-nav-v2 {
  height: 88px;
  padding: 0 32px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: space-between;
  backdrop-filter: blur(14px);
}

.wz-logo {
  border: 0;
  background: transparent;
  color: inherit;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 22px;
  font-weight: 850;
  cursor: pointer;
}

.wz-logo span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  color: #243124;
  background: #fff;
}

.wz-logo img {
  display: block;
  width: auto;
  height: 40px;
  object-fit: contain;
}

.wz-nav-v2 div {
  display: flex;
  align-items: center;
  gap: 54px;
}

.wz-nav-v2 a {
  color: rgba(255, 255, 255, 0.82);
  text-decoration: none;
  font-size: 13px;
  font-weight: 650;
}

.wz-nav-v2 aside {
  display: flex;
  gap: 12px;
}

.wz-nav-v2 aside button,
.wz-hero-copy-v2 button,
.wz-stack-v2 button,
.pricing-grid-v2 button,
.final-cta-v2 button,
.footer-v2 form button {
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 800;
}

.wz-nav-v2 aside button {
  height: 42px;
  padding: 0 18px;
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.72);
}

.wz-nav-v2 aside button:last-child {
  color: #152315;
  background: var(--lime);
  border-color: var(--lime);
}

.wz-hero-copy-v2 {
  width: min(700px, 100%);
  margin-top: 185px;
}

.wz-hero-copy-v2 h1 {
  margin: 0;
  font-size: clamp(44px, 6vw, 72px);
  line-height: 1.06;
  font-weight: 850;
}

.wz-hero-copy-v2 h1 span {
  display: block;
  color: var(--lime);
}

.wz-hero-copy-v2 p {
  margin: 28px 0 0;
  width: min(560px, 100%);
  color: rgba(255, 255, 255, 0.82);
  font-size: 18px;
  line-height: 1.6;
}

.wz-hero-copy-v2 div {
  margin-top: 28px;
  display: flex;
  gap: 14px;
}

.wz-hero-copy-v2 button {
  min-width: 180px;
  height: 48px;
  padding: 0 24px;
  color: #132312;
  background: var(--lime);
}

.wz-hero-copy-v2 button:last-child {
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.75);
}

.wz-section-v2 {
  width: min(1150px, calc(100% - 32px));
  margin: 0 auto;
  padding: 92px 0;
}

.split-head {
  display: grid;
  grid-template-columns: 1fr 0.9fr;
  gap: 160px;
  align-items: start;
  margin-bottom: 46px;
}

.center-head {
  width: min(760px, 100%);
  margin: 0 auto 48px;
  text-align: center;
}

.split-head h2,
.center-head h2,
.wz-stack-v2 h2,
.final-cta-v2 h2 {
  margin: 0;
  color: var(--ink);
  font-size: clamp(34px, 4vw, 46px);
  line-height: 1.14;
  font-weight: 850;
}

.split-head p,
.center-head p,
.wz-stack-v2 p,
.final-cta-v2 p {
  margin: 12px 0 0;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.55;
}

.wz-platform-v2,
.wz-chat-v2,
.wz-table-section,
.wz-security-v2,
.wz-faq-v2 {
  background:
    radial-gradient(circle at 18% 0%, rgba(155, 236, 104, 0.15), transparent 28%),
    #ffffff;
}

.platform-grid-v2 {
  display: grid;
  grid-template-columns: 1.25fr 1fr 1fr;
  gap: 18px;
}

.platform-grid-v2 article,
.security-grid-v2 article,
.testimonial-strip-v2 article,
.workspace-grid-v2 article {
  border-radius: 12px;
  border: 1px solid var(--line);
  background: #fff;
  box-shadow: 0 12px 28px rgba(30, 40, 28, 0.08);
}

.platform-grid-v2 article {
  position: relative;
  min-height: 245px;
  padding: 96px 22px 24px;
}

.platform-grid-v2 article.wide {
  padding-right: 265px;
}

.lime-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #172315;
  background: var(--lime);
  font-size: 18px;
}

.lime-icon img {
  display: block;
  max-width: 24px;
  max-height: 24px;
  object-fit: contain;
}

.platform-grid-v2 .lime-icon {
  position: absolute;
  top: 22px;
  left: 22px;
}

.platform-grid-v2 h3,
.workspace-grid-v2 h3,
.security-grid-v2 h3 {
  margin: 0;
  font-size: 16px;
  line-height: 1.35;
}

.platform-grid-v2 p,
.workspace-grid-v2 p,
.security-grid-v2 p {
  margin: 12px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.wz-job-visual {
  position: absolute;
  right: 18px;
  top: 22px;
  width: 230px;
  height: 190px;
  padding: 0;
  border-radius: 8px;
  background: #f1ffe7;
  overflow: hidden;
}

.wz-steps-v2 {
  padding-top: 86px;
}

.steps-layout-v2 {
  display: grid;
  grid-template-columns: 1fr 1.16fr;
  gap: 38px;
  align-items: center;
}

.wz-dashboard-visual {
  aspect-ratio: 463 / 376;
  height: auto;
  border-radius: 10px;
  background: #93e66a;
  box-shadow: 0 14px 32px rgba(35, 45, 35, 0.12);
  display: block;
  overflow: hidden;
}

.image-frame img,
.wz-workspace-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.wz-dashboard-visual.image-frame {
  position: relative;
  padding: 40px 0 0 42px;
  display: block;
  background: linear-gradient(135deg, #9cf06f 0%, #6fb355 100%);
  box-shadow: 0 14px 32px rgba(35, 45, 35, 0.12);
}

.wz-dashboard-visual.image-frame img {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: calc(100% - 42px);
  height: calc(100% - 40px);
  object-fit: fill;
}

.wz-dashboard-visual aside {
  padding: 18px 16px;
  color: #fff;
  background: #34404a;
  display: grid;
  align-content: start;
  gap: 13px;
}

.wz-dashboard-visual aside strong {
  margin-bottom: 10px;
  font-size: 13px;
}

.wz-dashboard-visual aside span {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.72);
}

.wz-dashboard-visual main {
  padding: 50px 20px 20px;
  background: #f8fff2;
}

.wz-dash-title {
  padding: 16px;
  border-radius: 8px;
  color: #fff;
  background: #49683e;
  font-weight: 800;
}

.wz-dash-tabs {
  margin: 18px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.wz-dash-tabs span {
  height: 52px;
  display: grid;
  place-items: center;
  border: 1px solid #d7e6cd;
  border-radius: 8px;
  color: #607064;
  background: #fff;
  font-size: 11px;
}

.wz-dashboard-visual table {
  width: 100%;
  border-collapse: collapse;
  color: #67736b;
  font-size: 11px;
}

.wz-dashboard-visual td {
  padding: 9px 8px;
  border-bottom: 1px solid #e1eadc;
}

.step-list-v2 {
  display: grid;
  gap: 14px;
}

.step-list-v2 article {
  min-height: 76px;
  padding: 18px;
  border: 1px solid #cfd8d0;
  border-radius: 8px;
  background: #f8faf8;
  display: grid;
  grid-template-columns: 34px 1fr;
  gap: 12px;
}

.step-list-v2 article.active {
  background: #f0ffe8;
  border-color: #b8e596;
}

.step-list-v2 article > span {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  background: #fff;
  color: #63a73a;
}

.step-list-v2 h3 {
  margin: 0;
  font-size: 15px;
}

.step-list-v2 p {
  margin: 7px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.45;
}

.flow-line-v2 {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-bottom: 34px;
}

.flow-line-v2::before {
  content: "";
  position: absolute;
  left: 7%;
  right: 7%;
  top: 24px;
  border-top: 1px dashed #9ea99f;
}

.flow-line-v2 div {
  position: relative;
  z-index: 1;
  text-align: center;
}

.flow-line-v2 span {
  width: 50px;
  height: 50px;
  margin: 0 auto 12px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 1px solid #9ca9a1;
  background: #fff;
  font-weight: 800;
}

.flow-line-v2 .active span {
  border-color: var(--lime);
  background: var(--lime);
}

.flow-line-v2 p {
  margin: 0;
  font-size: 13px;
  line-height: 1.35;
}

.chat-card-v2 {
  min-height: 360px;
  padding: 50px 38px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 14px 32px rgba(35, 45, 35, 0.1);
  display: grid;
  grid-template-columns: 1fr 0.9fr;
  gap: 60px;
  align-items: center;
}

.chat-card-v2 span {
  display: inline-flex;
  padding: 7px 15px;
  border-radius: 999px;
  background: var(--lime);
  color: #245225;
  font-size: 11px;
  font-weight: 800;
}

.chat-card-v2 h3 {
  margin: 20px 0 0;
  font-size: 22px;
}

.chat-card-v2 p,
.chat-card-v2 li {
  color: var(--muted);
  font-size: 14px;
  line-height: 1.55;
}

.chat-card-v2 ul {
  margin: 24px 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 12px;
}

.chat-card-v2 li {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-card-v2 li svg {
  color: #69a543;
}

.wz-chat-preview {
  position: relative;
  min-height: 270px;
  padding: 0;
  border-radius: 10px;
  overflow: visible;
  background:
    radial-gradient(#b7ec86 1px, transparent 1px) 0 0 / 16px 16px,
    #f0ffe8;
}

.wz-chat-preview > img:not(.dot-side):not(.dot-bottom) {
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
  height: 100%;
  min-height: 270px;
  object-fit: contain;
}

.wz-chat-preview .dot-side,
.wz-chat-preview .dot-bottom {
  position: absolute;
  z-index: 1;
  object-fit: contain;
}

.wz-chat-preview .dot-side {
  right: -14px;
  top: 54px;
  width: 49px;
  height: 93px;
}

.wz-chat-preview .dot-bottom {
  left: 82px;
  bottom: -10px;
  width: 84px;
  height: 27px;
}

.wz-dark-v2,
.wz-pricing-v2,
.wz-footer-wrap-v2 {
  padding: 92px max(16px, calc((100vw - 1150px) / 2));
  color: #fff;
  background:
    radial-gradient(circle at 45% 0%, rgba(155, 236, 104, 0.18), transparent 25%),
    linear-gradient(135deg, #121813, #1f2724);
}

.wz-dark-v2 .center-head h2,
.wz-dark-v2 .center-head p,
.wz-pricing-v2 .center-head h2,
.wz-pricing-v2 .center-head p {
  color: #fff;
}

.workspace-grid-v2 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: 350px 205px;
  gap: 16px;
}

.workspace-grid-v2 article {
  min-height: 0;
  padding: 15px;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.34);
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr);
  gap: 10px;
  overflow: hidden;
}

.workspace-grid-v2 article.workspace {
  grid-row: span 2;
}

.workspace-grid-v2 article.calendar {
  grid-column: span 2;
  grid-template-columns: minmax(180px, 0.84fr) minmax(310px, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 26px;
}

.workspace-grid-v2 article.calendar h3 {
  grid-column: 1;
  grid-row: 1;
  align-self: end;
}

.workspace-grid-v2 article.calendar p {
  grid-column: 1;
  grid-row: 2;
  align-self: start;
}

.workspace-grid-v2 article.calendar .wz-workspace-image {
  grid-column: 2;
  grid-row: 1 / span 2;
  width: 100%;
  max-width: 340px;
  justify-self: end;
  align-self: center;
}

.workspace-grid-v2 p {
  color: rgba(255, 255, 255, 0.84);
}

.wz-list-mini,
.wz-workspace-board,
.wz-calendar-mini {
  min-height: 132px;
  padding: 18px;
  border-radius: 8px;
  background: #f3ffe9;
  color: #1d291c;
}

.wz-workspace-image {
  min-height: 0;
  aspect-ratio: 340 / 271;
  border-radius: 8px;
  overflow: hidden;
  background: #f3ffe9;
}

.wz-workspace-image.tall {
  aspect-ratio: 340 / 498;
  min-height: 0;
  height: 100%;
}

.wz-workspace-image.wide {
  aspect-ratio: 340 / 200;
  min-height: 0;
  height: auto;
  align-self: center;
}

.wz-list-mini {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 10px;
}

.wz-list-mini span {
  padding: 9px;
  border-radius: 5px;
  background: #fff;
  font-size: 11px;
}

.wz-workspace-board {
  display: grid;
  gap: 14px;
}

.wz-workspace-board div {
  padding: 12px;
  border-radius: 5px;
  background: rgba(155, 236, 104, 0.65);
}

.wz-workspace-board span {
  display: block;
  margin-bottom: 9px;
  color: #38612a;
  font-size: 11px;
}

.wz-workspace-board i,
.wz-calendar-mini p {
  display: inline-block;
  width: 44%;
  height: 18px;
  margin-right: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.72);
}

.wz-calendar-mini {
  align-self: stretch;
}

.wz-calendar-mini div {
  margin-bottom: 18px;
  display: grid;
  gap: 8px;
}

.wz-calendar-mini span {
  color: #6f7c72;
  font-size: 11px;
}

.workflow-table-v2 {
  overflow: hidden;
  border: 1px solid #a8b8a4;
  border-radius: 10px;
}

.workflow-table-v2 .head,
.workflow-table-v2 .row {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.workflow-table-v2 .head span {
  padding: 18px 28px;
  color: #fff;
  background: #313c43;
  font-size: 12px;
  font-weight: 800;
}

.workflow-table-v2 .head span:last-child {
  color: #142113;
  background: var(--lime);
}

.workflow-table-v2 .row span {
  padding: 18px 28px;
  border-top: 1px solid #dfe8da;
  color: #4b564d;
  font-size: 14px;
}

.workflow-table-v2 .row span:last-child {
  background: #f1ffe9;
  color: #1e2a1f;
}

.wz-stack-v2 {
  min-height: 650px;
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  align-items: center;
  gap: 80px;
}

.wz-stack-v2 button {
  margin-top: 26px;
  height: 45px;
  padding: 0 50px;
  color: #182416;
  background: var(--lime);
}

.wz-orbit {
  position: relative;
  width: min(580px, 100%);
  aspect-ratio: 1;
  margin-left: auto;
}

.wz-orbit .ring {
  position: absolute;
  inset: 5.5%;
  border: 1px solid rgba(17, 24, 39, 0.045);
  border-radius: 50%;
  opacity: 0.2;
}

.wz-orbit .ring.two { inset: 21%; }
.wz-orbit .ring.three { inset: 36.5%; }

.wz-orbit-core {
  position: absolute;
  inset: 43%;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: transparent;
}

.wz-orbit-core img {
  width: 86%;
  height: auto;
  object-fit: contain;
}

.wz-orbit .icon {
  position: absolute;
  width: 54px;
  height: 54px;
  transform: translate(-50%, -50%);
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #4422c9;
  font-size: 24px;
}

.wz-orbit .icon img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.wz-orbit .gmail { left: 5.5%; top: 50%; color: #e94135; background: #fff; }
.wz-orbit .meet { left: 69%; top: 31%; color: #f8c823; background: #fff6cd; }
.wz-orbit .linkedin { left: 94.5%; top: 50%; background: #3166c8; }
.wz-orbit .whatsapp { left: 80%; top: 79%; background: #09bf45; }
.wz-orbit .calendar { left: 50%; top: 94.5%; color: #3d70ff; background: #fff; }
.wz-orbit .search { left: 42%; top: 78%; background: #4521d9; }
.wz-orbit .indeed { left: 30%; top: 26%; background: #2514b8; }
.wz-orbit .slack { left: 20%; top: 68%; background: #5b104f; }
.wz-orbit .charts { left: 61%; top: 6%; background: #08a77b; }

.wz-pricing-v2 {
  padding-top: 96px;
  padding-bottom: 96px;
}

.pricing-grid-v2 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 28px;
  align-items: center;
}

.pricing-grid-v2 article {
  min-height: 375px;
  padding: 30px 26px;
  border-radius: 12px;
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.25);
}

.pricing-grid-v2 article.featured {
  min-height: 475px;
  padding: 36px 28px;
  color: #1a2418;
  background: #f3ffe8;
}

.pricing-grid-v2 h3 {
  margin: 0;
  font-size: 20px;
}

.pricing-grid-v2 p {
  margin: 12px 0 22px;
  color: currentColor;
  opacity: 0.75;
  font-size: 13px;
}

.pricing-grid-v2 ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 13px;
}

.pricing-grid-v2 li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}

.pricing-grid-v2 li svg {
  color: var(--lime);
}

.pricing-grid-v2 .featured li svg {
  color: #5ca23a;
}

.pricing-grid-v2 strong {
  display: block;
  margin: 28px 0 20px;
  font-size: 38px;
}

.pricing-grid-v2 small {
  margin-left: 5px;
  font-size: 13px;
  font-weight: 500;
}

.pricing-grid-v2 button {
  width: 100%;
  height: 46px;
  color: #fff;
  background: transparent;
  border: 1px solid #fff;
}

.pricing-grid-v2 .featured button {
  color: #142113;
  background: var(--lime);
  border-color: #65a346;
}

.wz-testimonials-v2 {
  padding: 92px 0;
  overflow: hidden;
}

.wz-testimonials-v2 .center-head {
  margin-bottom: 42px;
}

.testimonial-window-v2 {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.testimonial-strip-v2 {
  width: max-content;
  display: flex;
  gap: 18px;
  transition: transform 0.35s ease;
}

.testimonial-strip-v2 article {
  width: 250px;
  flex: 0 0 250px;
  min-height: 290px;
  padding: 26px;
}

.testimonial-strip-v2 article.featured {
  background: var(--lime);
}

.testimonial-strip-v2 h3 {
  margin: 0 0 28px;
  font-size: 18px;
  color: #49617b;
}

.testimonial-logo {
  display: block;
  width: auto;
  height: 34px;
  margin-bottom: 28px;
  object-fit: contain;
}

.testimonial-strip-v2 p {
  min-height: 125px;
  margin: 0;
  color: #1d271f;
  font-size: 14px;
  line-height: 1.55;
}

.testimonial-strip-v2 div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.testimonial-strip-v2 div span,
.testimonial-avatar {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #31404a;
  font-weight: 850;
}

.testimonial-avatar {
  display: block;
  object-fit: cover;
  background: transparent;
}

.testimonial-strip-v2 strong,
.testimonial-strip-v2 small {
  display: block;
}

.testimonial-strip-v2 small {
  margin-top: 4px;
  color: #6c776f;
  font-weight: 500;
}

.carousel-dots {
  margin-top: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
}

.carousel-dots button {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  color: #fff;
  background: #3f4a52;
  cursor: pointer;
}

.carousel-dots .dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border-radius: 50%;
  background: #d1d8d1;
}

.carousel-dots .dot.active {
  background: #404b53;
}

.security-grid-v2 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
}

.security-grid-v2 article {
  min-height: 160px;
  padding: 28px 24px;
}

.security-grid-v2 .lime-icon {
  margin-bottom: 26px;
}

.wz-faq-v2 {
  width: min(760px, calc(100% - 32px));
  margin: 0 auto;
  padding: 70px 0 90px;
}

.wz-faq-v2 .center-head {
  margin-bottom: 26px;
}

.wz-faq-v2 details {
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #fff;
}

.wz-faq-v2 details + details {
  margin-top: 10px;
}

.wz-faq-v2 summary {
  padding: 15px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 650;
}

.wz-faq-v2 summary::-webkit-details-marker {
  display: none;
}

.wz-faq-v2 details p {
  margin: 0;
  padding: 0 18px 16px;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.wz-footer-wrap-v2 {
  position: relative;
  padding-top: 140px;
}

.final-cta-v2 {
  width: min(1010px, 100%);
  min-height: 220px;
  position: relative;
  z-index: 2;
  margin: 0 auto -88px;
  padding: 30px 46px;
  border-radius: 10px;
  color: #172315;
  background: linear-gradient(135deg, #c7f88b, #def7b6);
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 46px;
  align-items: center;
}

.final-cta-v2 h2 {
  font-size: 28px;
}

.final-cta-v2 button {
  min-width: 142px;
  height: 40px;
  margin: 16px 12px 0 0;
  color: #fff;
  background: #253126;
}

.final-cta-v2 button + button {
  color: #172315;
  background: transparent;
  border: 1px solid #172315;
}

.wz-cta-illustration {
  position: relative;
  width: 210px;
  height: 170px;
}

.wz-cta-illustration.image-frame {
  width: 267px;
  height: 267px;
}

.wz-cta-illustration .paper {
  position: absolute;
  left: 42px;
  top: 18px;
  width: 112px;
  height: 132px;
  padding: 16px;
  border-radius: 8px;
  background: #f5fbff;
  box-shadow: 0 12px 24px rgba(31, 45, 36, 0.15);
}

.wz-cta-illustration .paper svg {
  color: #4f63ff;
  font-size: 24px;
}

.wz-cta-illustration .paper i {
  display: block;
  height: 8px;
  margin-top: 13px;
  border-radius: 999px;
  background: #dce7ef;
}

.wz-cta-illustration .lens {
  position: absolute;
  right: 16px;
  top: 34px;
  width: 62px;
  height: 62px;
  border: 7px solid #f3a11b;
  border-radius: 50%;
}

.wz-cta-illustration .lens::after {
  content: "";
  position: absolute;
  right: -18px;
  bottom: -12px;
  width: 30px;
  height: 7px;
  border-radius: 999px;
  background: #f3a11b;
  transform: rotate(42deg);
}

.wz-cta-illustration .badge {
  position: absolute;
  z-index: 2;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 5px;
  color: #fff;
  font-size: 10px;
  font-weight: 850;
}

.wz-cta-illustration .red {
  left: 28px;
  top: 8px;
  background: #d73232;
}

.wz-cta-illustration .blue {
  left: 8px;
  bottom: 22px;
  background: #62a3ff;
}

.footer-v2 {
  width: min(1150px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.4fr 0.6fr 0.6fr 0.6fr;
  gap: 58px;
}

.footer-v2 p {
  width: min(390px, 100%);
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
}

.footer-v2 form {
  width: min(390px, 100%);
  height: 38px;
  display: grid;
  grid-template-columns: 1fr 100px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.28);
}

.footer-v2 input {
  border: 0;
  color: #fff;
  background: transparent;
  outline: none;
}

.footer-v2 input::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.footer-v2 form button {
  height: 28px;
  color: #142113;
  background: var(--lime);
  font-size: 11px;
}

.footer-v2 nav {
  display: grid;
  align-content: start;
  gap: 13px;
}

.footer-v2 a,
.footer-v2 nav button {
  padding: 0;
  border: 0;
  color: rgba(255, 255, 255, 0.72);
  background: transparent;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.footer-logo span {
  color: #1d2b1d;
  background: #fff;
}

@media (max-width: 980px) {
  .wz-nav-v2 div {
    display: none;
  }

  .split-head,
  .steps-layout-v2,
  .chat-card-v2,
  .wz-stack-v2,
  .final-cta-v2,
  .footer-v2 {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .platform-grid-v2,
  .pricing-grid-v2,
  .security-grid-v2,
  .workspace-grid-v2 {
    grid-template-columns: 1fr;
  }

  .workspace-grid-v2 {
    grid-template-rows: auto;
  }

  .platform-grid-v2 article.wide {
    padding-right: 22px;
  }

  .wz-job-visual {
    position: static;
    width: 100%;
    max-width: 280px;
    margin-top: 22px;
  }

  .workspace-grid-v2 article.workspace,
  .workspace-grid-v2 article.calendar {
    grid-row: auto;
    grid-column: auto;
  }

  .testimonial-strip-v2 {
    gap: 14px;
  }
}

@media (max-width: 680px) {
  .wz-hero-v2 {
    min-height: 620px;
    padding-top: 12px;
  }

  .wz-nav-v2 {
    height: auto;
    padding: 12px;
    gap: 14px;
  }

  .wz-nav-v2 aside button:first-child {
    display: none;
  }

  .wz-hero-copy-v2 {
    margin-top: 110px;
  }

  .wz-hero-copy-v2 h1 {
    font-size: 42px;
  }

  .wz-hero-copy-v2 div,
  .wz-nav-v2,
  .flow-line-v2 {
    flex-wrap: wrap;
  }

  .wz-hero-copy-v2 button {
    min-width: 138px;
  }

  .wz-section-v2 {
    width: min(100% - 18px, 1150px);
    padding: 62px 0;
  }

  .platform-grid-v2 article,
  .security-grid-v2 article {
    min-height: auto;
    padding-top: 82px;
  }

  .flow-line-v2 {
    display: flex;
    gap: 16px;
    justify-content: center;
  }

  .flow-line-v2::before {
    display: none;
  }

  .split-head,
  .center-head {
    margin-bottom: 30px;
  }

  .chat-card-v2 {
    padding: 24px;
  }

  .wz-chat-preview {
    min-height: 220px;
  }

  .wz-chat-preview > img:not(.dot-side):not(.dot-bottom) {
    min-height: 220px;
  }

  .wz-chat-preview .dot-side,
  .wz-chat-preview .dot-bottom {
    display: none;
  }

  .workflow-table-v2 .row,
  .workflow-table-v2 .head {
    grid-template-columns: 1fr;
  }

  .wz-orbit {
    width: 100%;
  }

  .final-cta-v2 {
    padding: 24px;
    width: min(100% - 18px, 1010px);
    grid-template-columns: 1fr;
    margin-bottom: -38px;
  }

  .wz-cta-illustration.image-frame {
    width: min(220px, 100%);
    height: 220px;
    justify-self: center;
  }

  .testimonial-strip-v2 article {
    width: 250px;
    flex-basis: 250px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WizboxLandingPage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uGAAuG;EACvG,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yDAAyD;EACzD,WAAW;EACX;;kEAEgE;AAClE;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;EAME,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,SAAS;EACT,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE;;WAES;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;;;;EAIE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB;;WAES;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,mDAAmD;EACnD,WAAW;EACX;;6CAE2C;AAC7C;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,uCAAuC;EACvC,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;AACd;;AAEA,sBAAsB,UAAU,EAAE;AAClC,wBAAwB,YAAY,EAAE;;AAEtC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB,UAAU,EAAE,QAAQ,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC3E,kBAAkB,SAAS,EAAE,QAAQ,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC5E,sBAAsB,WAAW,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAClE,sBAAsB,SAAS,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAChE,sBAAsB,SAAS,EAAE,UAAU,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC/E,oBAAoB,SAAS,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC9D,oBAAoB,SAAS,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC9D,mBAAmB,SAAS,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC7D,oBAAoB,SAAS,EAAE,OAAO,EAAE,mBAAmB,EAAE;;AAE7D;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qDAAqD;EACrD,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,8CAA8C;EAC9C,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;;;;IAME,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".wz-landing-v2 {\n  --ink: #18211b;\n  --muted: #5f6c63;\n  --soft: #f7fff1;\n  --lime: #9bec68;\n  --lime-2: #baf58a;\n  --line: #dfe8da;\n  --dark: #151b18;\n  --dark-2: #263327;\n  background: #fff;\n  color: var(--ink);\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  overflow-x: hidden;\n}\n\n.wz-landing-v2 * {\n  box-sizing: border-box;\n  letter-spacing: 0;\n}\n\n.wz-landing-v2 button,\n.wz-landing-v2 input {\n  font: inherit;\n}\n\n.wz-hero-v2 {\n  min-height: 775px;\n  padding: 24px max(16px, calc((100vw - 1150px) / 2)) 120px;\n  color: #fff;\n  background:\n    radial-gradient(circle at 30% 10%, rgba(155, 236, 104, 0.22), transparent 28%),\n    linear-gradient(134deg, #172216 0%, #233226 48%, #2e3b48 100%);\n}\n\n.wz-nav-v2 {\n  height: 88px;\n  padding: 0 32px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  backdrop-filter: blur(14px);\n}\n\n.wz-logo {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 22px;\n  font-weight: 850;\n  cursor: pointer;\n}\n\n.wz-logo span {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  border-radius: 4px;\n  color: #243124;\n  background: #fff;\n}\n\n.wz-logo img {\n  display: block;\n  width: auto;\n  height: 40px;\n  object-fit: contain;\n}\n\n.wz-nav-v2 div {\n  display: flex;\n  align-items: center;\n  gap: 54px;\n}\n\n.wz-nav-v2 a {\n  color: rgba(255, 255, 255, 0.82);\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.wz-nav-v2 aside {\n  display: flex;\n  gap: 12px;\n}\n\n.wz-nav-v2 aside button,\n.wz-hero-copy-v2 button,\n.wz-stack-v2 button,\n.pricing-grid-v2 button,\n.final-cta-v2 button,\n.footer-v2 form button {\n  border: 0;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n.wz-nav-v2 aside button {\n  height: 42px;\n  padding: 0 18px;\n  color: #fff;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.72);\n}\n\n.wz-nav-v2 aside button:last-child {\n  color: #152315;\n  background: var(--lime);\n  border-color: var(--lime);\n}\n\n.wz-hero-copy-v2 {\n  width: min(700px, 100%);\n  margin-top: 185px;\n}\n\n.wz-hero-copy-v2 h1 {\n  margin: 0;\n  font-size: clamp(44px, 6vw, 72px);\n  line-height: 1.06;\n  font-weight: 850;\n}\n\n.wz-hero-copy-v2 h1 span {\n  display: block;\n  color: var(--lime);\n}\n\n.wz-hero-copy-v2 p {\n  margin: 28px 0 0;\n  width: min(560px, 100%);\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 18px;\n  line-height: 1.6;\n}\n\n.wz-hero-copy-v2 div {\n  margin-top: 28px;\n  display: flex;\n  gap: 14px;\n}\n\n.wz-hero-copy-v2 button {\n  min-width: 180px;\n  height: 48px;\n  padding: 0 24px;\n  color: #132312;\n  background: var(--lime);\n}\n\n.wz-hero-copy-v2 button:last-child {\n  color: #fff;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.75);\n}\n\n.wz-section-v2 {\n  width: min(1150px, calc(100% - 32px));\n  margin: 0 auto;\n  padding: 92px 0;\n}\n\n.split-head {\n  display: grid;\n  grid-template-columns: 1fr 0.9fr;\n  gap: 160px;\n  align-items: start;\n  margin-bottom: 46px;\n}\n\n.center-head {\n  width: min(760px, 100%);\n  margin: 0 auto 48px;\n  text-align: center;\n}\n\n.split-head h2,\n.center-head h2,\n.wz-stack-v2 h2,\n.final-cta-v2 h2 {\n  margin: 0;\n  color: var(--ink);\n  font-size: clamp(34px, 4vw, 46px);\n  line-height: 1.14;\n  font-weight: 850;\n}\n\n.split-head p,\n.center-head p,\n.wz-stack-v2 p,\n.final-cta-v2 p {\n  margin: 12px 0 0;\n  color: var(--muted);\n  font-size: 16px;\n  line-height: 1.55;\n}\n\n.wz-platform-v2,\n.wz-chat-v2,\n.wz-table-section,\n.wz-security-v2,\n.wz-faq-v2 {\n  background:\n    radial-gradient(circle at 18% 0%, rgba(155, 236, 104, 0.15), transparent 28%),\n    #ffffff;\n}\n\n.platform-grid-v2 {\n  display: grid;\n  grid-template-columns: 1.25fr 1fr 1fr;\n  gap: 18px;\n}\n\n.platform-grid-v2 article,\n.security-grid-v2 article,\n.testimonial-strip-v2 article,\n.workspace-grid-v2 article {\n  border-radius: 12px;\n  border: 1px solid var(--line);\n  background: #fff;\n  box-shadow: 0 12px 28px rgba(30, 40, 28, 0.08);\n}\n\n.platform-grid-v2 article {\n  position: relative;\n  min-height: 245px;\n  padding: 96px 22px 24px;\n}\n\n.platform-grid-v2 article.wide {\n  padding-right: 265px;\n}\n\n.lime-icon {\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 8px;\n  color: #172315;\n  background: var(--lime);\n  font-size: 18px;\n}\n\n.lime-icon img {\n  display: block;\n  max-width: 24px;\n  max-height: 24px;\n  object-fit: contain;\n}\n\n.platform-grid-v2 .lime-icon {\n  position: absolute;\n  top: 22px;\n  left: 22px;\n}\n\n.platform-grid-v2 h3,\n.workspace-grid-v2 h3,\n.security-grid-v2 h3 {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.35;\n}\n\n.platform-grid-v2 p,\n.workspace-grid-v2 p,\n.security-grid-v2 p {\n  margin: 12px 0 0;\n  color: var(--muted);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.wz-job-visual {\n  position: absolute;\n  right: 18px;\n  top: 22px;\n  width: 230px;\n  height: 190px;\n  padding: 0;\n  border-radius: 8px;\n  background: #f1ffe7;\n  overflow: hidden;\n}\n\n.wz-steps-v2 {\n  padding-top: 86px;\n}\n\n.steps-layout-v2 {\n  display: grid;\n  grid-template-columns: 1fr 1.16fr;\n  gap: 38px;\n  align-items: center;\n}\n\n.wz-dashboard-visual {\n  aspect-ratio: 463 / 376;\n  height: auto;\n  border-radius: 10px;\n  background: #93e66a;\n  box-shadow: 0 14px 32px rgba(35, 45, 35, 0.12);\n  display: block;\n  overflow: hidden;\n}\n\n.image-frame img,\n.wz-workspace-image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.wz-dashboard-visual.image-frame {\n  position: relative;\n  padding: 40px 0 0 42px;\n  display: block;\n  background: linear-gradient(135deg, #9cf06f 0%, #6fb355 100%);\n  box-shadow: 0 14px 32px rgba(35, 45, 35, 0.12);\n}\n\n.wz-dashboard-visual.image-frame img {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  width: calc(100% - 42px);\n  height: calc(100% - 40px);\n  object-fit: fill;\n}\n\n.wz-dashboard-visual aside {\n  padding: 18px 16px;\n  color: #fff;\n  background: #34404a;\n  display: grid;\n  align-content: start;\n  gap: 13px;\n}\n\n.wz-dashboard-visual aside strong {\n  margin-bottom: 10px;\n  font-size: 13px;\n}\n\n.wz-dashboard-visual aside span {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.wz-dashboard-visual main {\n  padding: 50px 20px 20px;\n  background: #f8fff2;\n}\n\n.wz-dash-title {\n  padding: 16px;\n  border-radius: 8px;\n  color: #fff;\n  background: #49683e;\n  font-weight: 800;\n}\n\n.wz-dash-tabs {\n  margin: 18px 0;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n}\n\n.wz-dash-tabs span {\n  height: 52px;\n  display: grid;\n  place-items: center;\n  border: 1px solid #d7e6cd;\n  border-radius: 8px;\n  color: #607064;\n  background: #fff;\n  font-size: 11px;\n}\n\n.wz-dashboard-visual table {\n  width: 100%;\n  border-collapse: collapse;\n  color: #67736b;\n  font-size: 11px;\n}\n\n.wz-dashboard-visual td {\n  padding: 9px 8px;\n  border-bottom: 1px solid #e1eadc;\n}\n\n.step-list-v2 {\n  display: grid;\n  gap: 14px;\n}\n\n.step-list-v2 article {\n  min-height: 76px;\n  padding: 18px;\n  border: 1px solid #cfd8d0;\n  border-radius: 8px;\n  background: #f8faf8;\n  display: grid;\n  grid-template-columns: 34px 1fr;\n  gap: 12px;\n}\n\n.step-list-v2 article.active {\n  background: #f0ffe8;\n  border-color: #b8e596;\n}\n\n.step-list-v2 article > span {\n  width: 26px;\n  height: 26px;\n  display: grid;\n  place-items: center;\n  border-radius: 7px;\n  background: #fff;\n  color: #63a73a;\n}\n\n.step-list-v2 h3 {\n  margin: 0;\n  font-size: 15px;\n}\n\n.step-list-v2 p {\n  margin: 7px 0 0;\n  color: var(--muted);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.flow-line-v2 {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  margin-bottom: 34px;\n}\n\n.flow-line-v2::before {\n  content: \"\";\n  position: absolute;\n  left: 7%;\n  right: 7%;\n  top: 24px;\n  border-top: 1px dashed #9ea99f;\n}\n\n.flow-line-v2 div {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n}\n\n.flow-line-v2 span {\n  width: 50px;\n  height: 50px;\n  margin: 0 auto 12px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  border: 1px solid #9ca9a1;\n  background: #fff;\n  font-weight: 800;\n}\n\n.flow-line-v2 .active span {\n  border-color: var(--lime);\n  background: var(--lime);\n}\n\n.flow-line-v2 p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.chat-card-v2 {\n  min-height: 360px;\n  padding: 50px 38px;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 14px 32px rgba(35, 45, 35, 0.1);\n  display: grid;\n  grid-template-columns: 1fr 0.9fr;\n  gap: 60px;\n  align-items: center;\n}\n\n.chat-card-v2 span {\n  display: inline-flex;\n  padding: 7px 15px;\n  border-radius: 999px;\n  background: var(--lime);\n  color: #245225;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.chat-card-v2 h3 {\n  margin: 20px 0 0;\n  font-size: 22px;\n}\n\n.chat-card-v2 p,\n.chat-card-v2 li {\n  color: var(--muted);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.chat-card-v2 ul {\n  margin: 24px 0 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 12px;\n}\n\n.chat-card-v2 li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-card-v2 li svg {\n  color: #69a543;\n}\n\n.wz-chat-preview {\n  position: relative;\n  min-height: 270px;\n  padding: 0;\n  border-radius: 10px;\n  overflow: visible;\n  background:\n    radial-gradient(#b7ec86 1px, transparent 1px) 0 0 / 16px 16px,\n    #f0ffe8;\n}\n\n.wz-chat-preview > img:not(.dot-side):not(.dot-bottom) {\n  position: relative;\n  z-index: 2;\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-height: 270px;\n  object-fit: contain;\n}\n\n.wz-chat-preview .dot-side,\n.wz-chat-preview .dot-bottom {\n  position: absolute;\n  z-index: 1;\n  object-fit: contain;\n}\n\n.wz-chat-preview .dot-side {\n  right: -14px;\n  top: 54px;\n  width: 49px;\n  height: 93px;\n}\n\n.wz-chat-preview .dot-bottom {\n  left: 82px;\n  bottom: -10px;\n  width: 84px;\n  height: 27px;\n}\n\n.wz-dark-v2,\n.wz-pricing-v2,\n.wz-footer-wrap-v2 {\n  padding: 92px max(16px, calc((100vw - 1150px) / 2));\n  color: #fff;\n  background:\n    radial-gradient(circle at 45% 0%, rgba(155, 236, 104, 0.18), transparent 25%),\n    linear-gradient(135deg, #121813, #1f2724);\n}\n\n.wz-dark-v2 .center-head h2,\n.wz-dark-v2 .center-head p,\n.wz-pricing-v2 .center-head h2,\n.wz-pricing-v2 .center-head p {\n  color: #fff;\n}\n\n.workspace-grid-v2 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: 350px 205px;\n  gap: 16px;\n}\n\n.workspace-grid-v2 article {\n  min-height: 0;\n  padding: 15px;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.34);\n  display: grid;\n  grid-template-rows: auto auto minmax(0, 1fr);\n  gap: 10px;\n  overflow: hidden;\n}\n\n.workspace-grid-v2 article.workspace {\n  grid-row: span 2;\n}\n\n.workspace-grid-v2 article.calendar {\n  grid-column: span 2;\n  grid-template-columns: minmax(180px, 0.84fr) minmax(310px, 1fr);\n  grid-template-rows: auto auto;\n  align-items: center;\n  column-gap: 26px;\n}\n\n.workspace-grid-v2 article.calendar h3 {\n  grid-column: 1;\n  grid-row: 1;\n  align-self: end;\n}\n\n.workspace-grid-v2 article.calendar p {\n  grid-column: 1;\n  grid-row: 2;\n  align-self: start;\n}\n\n.workspace-grid-v2 article.calendar .wz-workspace-image {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  width: 100%;\n  max-width: 340px;\n  justify-self: end;\n  align-self: center;\n}\n\n.workspace-grid-v2 p {\n  color: rgba(255, 255, 255, 0.84);\n}\n\n.wz-list-mini,\n.wz-workspace-board,\n.wz-calendar-mini {\n  min-height: 132px;\n  padding: 18px;\n  border-radius: 8px;\n  background: #f3ffe9;\n  color: #1d291c;\n}\n\n.wz-workspace-image {\n  min-height: 0;\n  aspect-ratio: 340 / 271;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f3ffe9;\n}\n\n.wz-workspace-image.tall {\n  aspect-ratio: 340 / 498;\n  min-height: 0;\n  height: 100%;\n}\n\n.wz-workspace-image.wide {\n  aspect-ratio: 340 / 200;\n  min-height: 0;\n  height: auto;\n  align-self: center;\n}\n\n.wz-list-mini {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 10px;\n}\n\n.wz-list-mini span {\n  padding: 9px;\n  border-radius: 5px;\n  background: #fff;\n  font-size: 11px;\n}\n\n.wz-workspace-board {\n  display: grid;\n  gap: 14px;\n}\n\n.wz-workspace-board div {\n  padding: 12px;\n  border-radius: 5px;\n  background: rgba(155, 236, 104, 0.65);\n}\n\n.wz-workspace-board span {\n  display: block;\n  margin-bottom: 9px;\n  color: #38612a;\n  font-size: 11px;\n}\n\n.wz-workspace-board i,\n.wz-calendar-mini p {\n  display: inline-block;\n  width: 44%;\n  height: 18px;\n  margin-right: 8px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.wz-calendar-mini {\n  align-self: stretch;\n}\n\n.wz-calendar-mini div {\n  margin-bottom: 18px;\n  display: grid;\n  gap: 8px;\n}\n\n.wz-calendar-mini span {\n  color: #6f7c72;\n  font-size: 11px;\n}\n\n.workflow-table-v2 {\n  overflow: hidden;\n  border: 1px solid #a8b8a4;\n  border-radius: 10px;\n}\n\n.workflow-table-v2 .head,\n.workflow-table-v2 .row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\n.workflow-table-v2 .head span {\n  padding: 18px 28px;\n  color: #fff;\n  background: #313c43;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.workflow-table-v2 .head span:last-child {\n  color: #142113;\n  background: var(--lime);\n}\n\n.workflow-table-v2 .row span {\n  padding: 18px 28px;\n  border-top: 1px solid #dfe8da;\n  color: #4b564d;\n  font-size: 14px;\n}\n\n.workflow-table-v2 .row span:last-child {\n  background: #f1ffe9;\n  color: #1e2a1f;\n}\n\n.wz-stack-v2 {\n  min-height: 650px;\n  display: grid;\n  grid-template-columns: 0.8fr 1.2fr;\n  align-items: center;\n  gap: 80px;\n}\n\n.wz-stack-v2 button {\n  margin-top: 26px;\n  height: 45px;\n  padding: 0 50px;\n  color: #182416;\n  background: var(--lime);\n}\n\n.wz-orbit {\n  position: relative;\n  width: min(580px, 100%);\n  aspect-ratio: 1;\n  margin-left: auto;\n}\n\n.wz-orbit .ring {\n  position: absolute;\n  inset: 5.5%;\n  border: 1px solid rgba(17, 24, 39, 0.045);\n  border-radius: 50%;\n  opacity: 0.2;\n}\n\n.wz-orbit .ring.two { inset: 21%; }\n.wz-orbit .ring.three { inset: 36.5%; }\n\n.wz-orbit-core {\n  position: absolute;\n  inset: 43%;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n  background: transparent;\n}\n\n.wz-orbit-core img {\n  width: 86%;\n  height: auto;\n  object-fit: contain;\n}\n\n.wz-orbit .icon {\n  position: absolute;\n  width: 54px;\n  height: 54px;\n  transform: translate(-50%, -50%);\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  color: #fff;\n  background: #4422c9;\n  font-size: 24px;\n}\n\n.wz-orbit .icon img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.wz-orbit .gmail { left: 5.5%; top: 50%; color: #e94135; background: #fff; }\n.wz-orbit .meet { left: 69%; top: 31%; color: #f8c823; background: #fff6cd; }\n.wz-orbit .linkedin { left: 94.5%; top: 50%; background: #3166c8; }\n.wz-orbit .whatsapp { left: 80%; top: 79%; background: #09bf45; }\n.wz-orbit .calendar { left: 50%; top: 94.5%; color: #3d70ff; background: #fff; }\n.wz-orbit .search { left: 42%; top: 78%; background: #4521d9; }\n.wz-orbit .indeed { left: 30%; top: 26%; background: #2514b8; }\n.wz-orbit .slack { left: 20%; top: 68%; background: #5b104f; }\n.wz-orbit .charts { left: 61%; top: 6%; background: #08a77b; }\n\n.wz-pricing-v2 {\n  padding-top: 96px;\n  padding-bottom: 96px;\n}\n\n.pricing-grid-v2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 28px;\n  align-items: center;\n}\n\n.pricing-grid-v2 article {\n  min-height: 375px;\n  padding: 30px 26px;\n  border-radius: 12px;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.25);\n}\n\n.pricing-grid-v2 article.featured {\n  min-height: 475px;\n  padding: 36px 28px;\n  color: #1a2418;\n  background: #f3ffe8;\n}\n\n.pricing-grid-v2 h3 {\n  margin: 0;\n  font-size: 20px;\n}\n\n.pricing-grid-v2 p {\n  margin: 12px 0 22px;\n  color: currentColor;\n  opacity: 0.75;\n  font-size: 13px;\n}\n\n.pricing-grid-v2 ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 13px;\n}\n\n.pricing-grid-v2 li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n}\n\n.pricing-grid-v2 li svg {\n  color: var(--lime);\n}\n\n.pricing-grid-v2 .featured li svg {\n  color: #5ca23a;\n}\n\n.pricing-grid-v2 strong {\n  display: block;\n  margin: 28px 0 20px;\n  font-size: 38px;\n}\n\n.pricing-grid-v2 small {\n  margin-left: 5px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.pricing-grid-v2 button {\n  width: 100%;\n  height: 46px;\n  color: #fff;\n  background: transparent;\n  border: 1px solid #fff;\n}\n\n.pricing-grid-v2 .featured button {\n  color: #142113;\n  background: var(--lime);\n  border-color: #65a346;\n}\n\n.wz-testimonials-v2 {\n  padding: 92px 0;\n  overflow: hidden;\n}\n\n.wz-testimonials-v2 .center-head {\n  margin-bottom: 42px;\n}\n\n.testimonial-window-v2 {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n.testimonial-strip-v2 {\n  width: max-content;\n  display: flex;\n  gap: 18px;\n  transition: transform 0.35s ease;\n}\n\n.testimonial-strip-v2 article {\n  width: 250px;\n  flex: 0 0 250px;\n  min-height: 290px;\n  padding: 26px;\n}\n\n.testimonial-strip-v2 article.featured {\n  background: var(--lime);\n}\n\n.testimonial-strip-v2 h3 {\n  margin: 0 0 28px;\n  font-size: 18px;\n  color: #49617b;\n}\n\n.testimonial-logo {\n  display: block;\n  width: auto;\n  height: 34px;\n  margin-bottom: 28px;\n  object-fit: contain;\n}\n\n.testimonial-strip-v2 p {\n  min-height: 125px;\n  margin: 0;\n  color: #1d271f;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.testimonial-strip-v2 div {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.testimonial-strip-v2 div span,\n.testimonial-avatar {\n  width: 46px;\n  height: 46px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  color: #fff;\n  background: #31404a;\n  font-weight: 850;\n}\n\n.testimonial-avatar {\n  display: block;\n  object-fit: cover;\n  background: transparent;\n}\n\n.testimonial-strip-v2 strong,\n.testimonial-strip-v2 small {\n  display: block;\n}\n\n.testimonial-strip-v2 small {\n  margin-top: 4px;\n  color: #6c776f;\n  font-weight: 500;\n}\n\n.carousel-dots {\n  margin-top: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n}\n\n.carousel-dots button {\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 50%;\n  color: #fff;\n  background: #3f4a52;\n  cursor: pointer;\n}\n\n.carousel-dots .dot {\n  width: 8px;\n  height: 8px;\n  padding: 0;\n  border-radius: 50%;\n  background: #d1d8d1;\n}\n\n.carousel-dots .dot.active {\n  background: #404b53;\n}\n\n.security-grid-v2 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 22px;\n}\n\n.security-grid-v2 article {\n  min-height: 160px;\n  padding: 28px 24px;\n}\n\n.security-grid-v2 .lime-icon {\n  margin-bottom: 26px;\n}\n\n.wz-faq-v2 {\n  width: min(760px, calc(100% - 32px));\n  margin: 0 auto;\n  padding: 70px 0 90px;\n}\n\n.wz-faq-v2 .center-head {\n  margin-bottom: 26px;\n}\n\n.wz-faq-v2 details {\n  border: 1px solid var(--line);\n  border-radius: 7px;\n  background: #fff;\n}\n\n.wz-faq-v2 details + details {\n  margin-top: 10px;\n}\n\n.wz-faq-v2 summary {\n  padding: 15px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  list-style: none;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.wz-faq-v2 summary::-webkit-details-marker {\n  display: none;\n}\n\n.wz-faq-v2 details p {\n  margin: 0;\n  padding: 0 18px 16px;\n  color: var(--muted);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.wz-footer-wrap-v2 {\n  position: relative;\n  padding-top: 140px;\n}\n\n.final-cta-v2 {\n  width: min(1010px, 100%);\n  min-height: 220px;\n  position: relative;\n  z-index: 2;\n  margin: 0 auto -88px;\n  padding: 30px 46px;\n  border-radius: 10px;\n  color: #172315;\n  background: linear-gradient(135deg, #c7f88b, #def7b6);\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 46px;\n  align-items: center;\n}\n\n.final-cta-v2 h2 {\n  font-size: 28px;\n}\n\n.final-cta-v2 button {\n  min-width: 142px;\n  height: 40px;\n  margin: 16px 12px 0 0;\n  color: #fff;\n  background: #253126;\n}\n\n.final-cta-v2 button + button {\n  color: #172315;\n  background: transparent;\n  border: 1px solid #172315;\n}\n\n.wz-cta-illustration {\n  position: relative;\n  width: 210px;\n  height: 170px;\n}\n\n.wz-cta-illustration.image-frame {\n  width: 267px;\n  height: 267px;\n}\n\n.wz-cta-illustration .paper {\n  position: absolute;\n  left: 42px;\n  top: 18px;\n  width: 112px;\n  height: 132px;\n  padding: 16px;\n  border-radius: 8px;\n  background: #f5fbff;\n  box-shadow: 0 12px 24px rgba(31, 45, 36, 0.15);\n}\n\n.wz-cta-illustration .paper svg {\n  color: #4f63ff;\n  font-size: 24px;\n}\n\n.wz-cta-illustration .paper i {\n  display: block;\n  height: 8px;\n  margin-top: 13px;\n  border-radius: 999px;\n  background: #dce7ef;\n}\n\n.wz-cta-illustration .lens {\n  position: absolute;\n  right: 16px;\n  top: 34px;\n  width: 62px;\n  height: 62px;\n  border: 7px solid #f3a11b;\n  border-radius: 50%;\n}\n\n.wz-cta-illustration .lens::after {\n  content: \"\";\n  position: absolute;\n  right: -18px;\n  bottom: -12px;\n  width: 30px;\n  height: 7px;\n  border-radius: 999px;\n  background: #f3a11b;\n  transform: rotate(42deg);\n}\n\n.wz-cta-illustration .badge {\n  position: absolute;\n  z-index: 2;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  border-radius: 5px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 850;\n}\n\n.wz-cta-illustration .red {\n  left: 28px;\n  top: 8px;\n  background: #d73232;\n}\n\n.wz-cta-illustration .blue {\n  left: 8px;\n  bottom: 22px;\n  background: #62a3ff;\n}\n\n.footer-v2 {\n  width: min(1150px, 100%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.4fr 0.6fr 0.6fr 0.6fr;\n  gap: 58px;\n}\n\n.footer-v2 p {\n  width: min(390px, 100%);\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.6;\n}\n\n.footer-v2 form {\n  width: min(390px, 100%);\n  height: 38px;\n  display: grid;\n  grid-template-columns: 1fr 100px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.28);\n}\n\n.footer-v2 input {\n  border: 0;\n  color: #fff;\n  background: transparent;\n  outline: none;\n}\n\n.footer-v2 input::placeholder {\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.footer-v2 form button {\n  height: 28px;\n  color: #142113;\n  background: var(--lime);\n  font-size: 11px;\n}\n\n.footer-v2 nav {\n  display: grid;\n  align-content: start;\n  gap: 13px;\n}\n\n.footer-v2 a,\n.footer-v2 nav button {\n  padding: 0;\n  border: 0;\n  color: rgba(255, 255, 255, 0.72);\n  background: transparent;\n  text-align: left;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.footer-logo span {\n  color: #1d2b1d;\n  background: #fff;\n}\n\n@media (max-width: 980px) {\n  .wz-nav-v2 div {\n    display: none;\n  }\n\n  .split-head,\n  .steps-layout-v2,\n  .chat-card-v2,\n  .wz-stack-v2,\n  .final-cta-v2,\n  .footer-v2 {\n    grid-template-columns: 1fr;\n    gap: 28px;\n  }\n\n  .platform-grid-v2,\n  .pricing-grid-v2,\n  .security-grid-v2,\n  .workspace-grid-v2 {\n    grid-template-columns: 1fr;\n  }\n\n  .workspace-grid-v2 {\n    grid-template-rows: auto;\n  }\n\n  .platform-grid-v2 article.wide {\n    padding-right: 22px;\n  }\n\n  .wz-job-visual {\n    position: static;\n    width: 100%;\n    max-width: 280px;\n    margin-top: 22px;\n  }\n\n  .workspace-grid-v2 article.workspace,\n  .workspace-grid-v2 article.calendar {\n    grid-row: auto;\n    grid-column: auto;\n  }\n\n  .testimonial-strip-v2 {\n    gap: 14px;\n  }\n}\n\n@media (max-width: 680px) {\n  .wz-hero-v2 {\n    min-height: 620px;\n    padding-top: 12px;\n  }\n\n  .wz-nav-v2 {\n    height: auto;\n    padding: 12px;\n    gap: 14px;\n  }\n\n  .wz-nav-v2 aside button:first-child {\n    display: none;\n  }\n\n  .wz-hero-copy-v2 {\n    margin-top: 110px;\n  }\n\n  .wz-hero-copy-v2 h1 {\n    font-size: 42px;\n  }\n\n  .wz-hero-copy-v2 div,\n  .wz-nav-v2,\n  .flow-line-v2 {\n    flex-wrap: wrap;\n  }\n\n  .wz-hero-copy-v2 button {\n    min-width: 138px;\n  }\n\n  .wz-section-v2 {\n    width: min(100% - 18px, 1150px);\n    padding: 62px 0;\n  }\n\n  .platform-grid-v2 article,\n  .security-grid-v2 article {\n    min-height: auto;\n    padding-top: 82px;\n  }\n\n  .flow-line-v2 {\n    display: flex;\n    gap: 16px;\n    justify-content: center;\n  }\n\n  .flow-line-v2::before {\n    display: none;\n  }\n\n  .split-head,\n  .center-head {\n    margin-bottom: 30px;\n  }\n\n  .chat-card-v2 {\n    padding: 24px;\n  }\n\n  .wz-chat-preview {\n    min-height: 220px;\n  }\n\n  .wz-chat-preview > img:not(.dot-side):not(.dot-bottom) {\n    min-height: 220px;\n  }\n\n  .wz-chat-preview .dot-side,\n  .wz-chat-preview .dot-bottom {\n    display: none;\n  }\n\n  .workflow-table-v2 .row,\n  .workflow-table-v2 .head {\n    grid-template-columns: 1fr;\n  }\n\n  .wz-orbit {\n    width: 100%;\n  }\n\n  .final-cta-v2 {\n    padding: 24px;\n    width: min(100% - 18px, 1010px);\n    grid-template-columns: 1fr;\n    margin-bottom: -38px;\n  }\n\n  .wz-cta-illustration.image-frame {\n    width: min(220px, 100%);\n    height: 220px;\n    justify-self: center;\n  }\n\n  .testimonial-strip-v2 article {\n    width: 250px;\n    flex-basis: 250px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
